import { fetchUserSettings, updateUserSettings } from "../../services/auth/userService";

const state = {
 authResult: null,
 userInfo: null,
 isSetupComplete: false,
};

const mutations = {
 setAuthResult(state, requestedPage) {
  state.authResult = requestedPage.data;
 },
 logout(state) {
  state.authResult = null;
 },
 setUserInfo(state, userInfo) {
  state.userInfo = userInfo;
 },
 setUserSettings(state, settings) {
  state.userInfo.settings = settings;
 },
 isSetupComplete(state, isSetupComplete) {
  state.isSetupComplete = isSetupComplete;
 },
};

const actions = {
 setAuthResult(context, requestedPage) {
  context.commit("setAuthResult", {
   data: requestedPage,
  });
 },
 logout(context) {
  context.commit("logout");
 },
 setUserInfo(context, userInfo) {
  context.commit("setUserInfo", userInfo);
 },
 isSetupComplete(context, isSetupComplete) {
  context.commit("isSetupComplete", isSetupComplete);
 },
 async fetchUserSettings(context) {
  const userSettings = await fetchUserSettings();
  context.commit("setUserSettings", userSettings.data.settings);
 },
 async updateUserSettings(context, requestBody) {
  const userSettings = await updateUserSettings(requestBody);
  // context.dispatch("fetchUserSettings");

 }
};

const getters = {
 getAuthResult(state) {
  return state.authResult;
 },
 isAuthenticated(state) {
  if (state.authResult != null) {
   let token = state.authResult.accessToken;
   var base64Url = token.split(".")[1];
   var base64 = decodeURIComponent(
    atob(base64Url)
     .split("")
     .map(function(c) {
      return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
     })
     .join(""),
   );

   let parsedToken = JSON.parse(base64);
   var milliseconds = new Date().getTime();
   if (parsedToken.exp < milliseconds / 1000) {
    return false;
   }
   return true;
  }
  return false;
 },
 getUserInfo(state) {
  return state.userInfo;
 },
 isSetupComplete(state) {
  return state.isSetupComplete;
 },
};

export default {
 namespaced: false,
 state,
 mutations,
 actions,
 getters,
};
